namespace TabAurous.Production {
    export namespace OpenWorkOrdersService {
        export const baseUrl = 'Production/OpenWorkOrders';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/OpenWorkOrders/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OpenWorkOrdersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
